"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _KYC_IMFormComponent = _interopRequireDefault(require("./KYC_IMFormComponent"));
var _reduxForm = require("redux-form");
var _config = _interopRequireDefault(require("../../../config"));
var _kycIdentityMindActions = require("../../../redux/actions/kycIdentityMindActions");
var _KYC_IMFormHelpers = require("./KYC_IMFormHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _state$user = state.user,
    accountId = _state$user.selectedAccountId,
    _state$user$userInfo = _state$user.userInfo,
    UserId = _state$user$userInfo.UserId,
    email = _state$user$userInfo.Email,
    UserName = _state$user$userInfo.UserName;
  var _config$KYC = _config["default"].KYC,
    MinimumVerificationLevel = _config$KYC.MinimumVerificationLevel,
    useAccountId = _config$KYC.useAccountId,
    levels = _config$KYC.levels;
  var level = levels[0];
  var missingFields = (0, _KYC_IMFormHelpers.getMissingMandatoryFields)(levels);
  var uploadFields = (0, _KYC_IMFormHelpers.getAdditionalValidationFields)(level);
  (0, _KYC_IMFormHelpers.updateLevelFields)(level, {
    suppressDefaultValidators: _config["default"].KYC.DisableIMRequiredFields
  });
  return {
    accountId: accountId,
    UserId: UserId,
    UserName: UserName,
    email: email,
    useAccountId: useAccountId,
    missingFields: missingFields,
    level: level,
    MinimumVerificationLevel: MinimumVerificationLevel,
    uploadFields: uploadFields,
    formValues: (0, _reduxForm.getFormValues)('kycIMForm')(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    validateUserRegistrationIdentityMind: function validateUserRegistrationIdentityMind(payload) {
      return dispatch((0, _kycIdentityMindActions.validateUserRegistrationIdentityMind)(payload));
    },
    reset: function reset() {
      return dispatch((0, _reduxForm.reset)('kycIMForm'));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_KYC_IMFormComponent["default"]);